export enum PRRoutesEnum {
  CUSTOMERS = 'customers',
  PROJECTS = 'projects',
  PROJECTS_OVERVIEW = 'projects-overview',
  DASHBOARD_WITH_PROJECT_ID = ':projectId/dashboard',
  DOCUMENTS_WITH_PROJECT_ID = ':projectId/documents',
  INBOX_WITH_PROJECT_ID = ':projectId/inbox',
  DASHBOARD = 'dashboard',
  DOCUMENTS = 'documents',
  DOCUMENT_PREVIEW = 'document',
  INBOX = 'inbox',
  // Configurations
  PROJECT_DOCUMENT_TYPE_CONFIGURATION = ':projectId/configurations/project_config/document_type',
  GLOBAL_CONFIGURATION = 'configurations/global_config',
  GLOBAL_DOCUMENT_TYPE_CONFIGURATION = 'configurations/global_config/document_type',
  // Error
  ACCESS_DENIED = 'access_denied',
}